import SiteInfo from './SiteInfo';

export default SiteInfo;
